/**
 * quiltBlocks — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {SQUARE, tagline, chips, type ToilePack} from './data'

export const quiltBlocksPack: ToilePack = {
    slug: 'quilt-blocks',
    category: 'quilt',
    name: 'Quilt blocks',
    tagline: tagline('blocks', 'blocks', 'fabric styles'),
    chips: chips('blocks', 'styles'),
    ratio: SQUARE,
    readings: [
        {key: 'logcabin', label: 'Log cabin', subject: 'strips ringing a small center square in widening rounds'},
        {key: 'geese', label: 'Flying geese', subject: 'rows of triangles all pointing the same way'},
        {key: 'star', label: 'Sawtooth star', subject: 'a center square framed by eight triangle points'},
    ],
    styles: [
        {key: 'calico', label: 'Calico', style: 'traditional small-print reproduction cottons', palette: 'muted reds, indigos and butter creams', framing: 'one block, flat and straight on'},
        {key: 'solids', label: 'Modern solids', style: 'flat unprinted cotton, crisp and graphic', palette: 'two brights against white', framing: 'one block, flat and straight on'},
        {key: 'scrappy', label: 'Scrappy', style: 'every piece a different leftover print', palette: 'mismatched and cheerful', framing: 'one block, flat and straight on'},
    ],
    directions: ['a dresden plate instead', 'in navy and cream', 'simpler, fewer pieces'],
}
